import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CsrfService {
  private csrfToken: string | null = null;

  constructor(private http: HttpClient) {}

  /**
   * Obtener token CSRF del servidor
   */
  async fetchCsrfToken(): Promise<string> {
    try {
      const response: any = await this.http.get(
        `${environment.apiUrl}/common/auth/csrf-token`,
        {
          headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
        }
      ).toPromise();

      if (response && response.result && response.result.csrfToken) {
        this.csrfToken = response.result.csrfToken;
        return this.csrfToken;
      }
      throw new Error('CSRF token not received');
    } catch (error) {
      console.error('Error fetching CSRF token:', error);
      throw error;
    }
  }

  /**
   * Obtener token CSRF actual
   */
  getToken(): string | null {
    return this.csrfToken;
  }

  /**
   * Limpiar token CSRF
   */
  clearToken(): void {
    this.csrfToken = null;
  }

  /**
   * Verificar si hay token CSRF
   */
  hasToken(): boolean {
    return this.csrfToken !== null;
  }
}
